import React, { useEffect, useState } from 'react';
import axiosInstance from '../interceptors/axios';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';


const Login = (props) => {
  const [errorMessages, setErrorMessages] = useState([]);
  const navigate = useNavigate();

  const { isLoggedIn, setIsLoggedIn, setEmail } = props;

  useEffect(() => {
    if (isLoggedIn) navigate('/dashboard/view-booked-classes');
  }, [isLoggedIn, navigate]);

  const [login_email, setLoginEmail] = useState('');
  const [login_password, setLoginPassword] = useState('');

  const handleLogin = async (ev) => {
    ev.preventDefault();
    const email = ev.target.email.value;
    const password = ev.target.password.value;
    const formData = { email, password };

    try {
      const res = await axiosInstance.post('/login', formData);
      const data = res.data;

      if (data.success) {
        setErrorMessages([]);
        setIsLoggedIn(true);
        setEmail(email);
        navigate('/dashboard/view-booked-classes');
        Cookies.set('access_token', data.access_token, { expires: 60 });
        Cookies.set('refresh_token', data.refresh_token, { expires: 60 });
        Cookies.set('regybox_token', data.regybox_token, { expires: 60 });
      } else {
        setErrorMessages([data.message]);
      }
    } catch (err) {
      const errorMsg = err.response?.data?.message || ['An error occurred. Please try again later.'];
      setErrorMessages(errorMsg);
    }
  };

  return (
    <div className="login-container">
      <main className="login-form-wrapper">
        {errorMessages.length > 0 && (
          <div className="alert alert-danger" role="alert" style={{ textAlign: 'left' }}>
            {errorMessages.map((message, index) => (
              <div key={index}>{message}</div>
            ))}
          </div>
        )}
        <img className="logo mb-4" src={`${process.env.PUBLIC_URL}/images/logo.svg`} alt="Logo" />
        <h2>Welcome Back</h2>
        <p style={{ color: 'var(--rb-text-secondary)', fontSize: '0.88rem', marginBottom: '28px' }}>
          Sign in to manage your classes
        </p>
        <form onSubmit={handleLogin}>
          <div className="form-floating" style={{ marginBottom: '12px' }}>
            <input
              type="email"
              className="form-control"
              name="email"
              id="floatingInput"
              placeholder="name@example.com"
              value={login_email}
              onChange={(e) => setLoginEmail(e.target.value)}
              required
            />
            <label htmlFor="floatingInput">Email address</label>
          </div>
          <div className="form-floating" style={{ marginBottom: '20px' }}>
            <input
              type="password"
              className="form-control"
              name="password"
              id="floatingPassword"
              placeholder="Password"
              value={login_password}
              onChange={(e) => setLoginPassword(e.target.value)}
              required
            />
            <label htmlFor="floatingPassword">Password</label>
          </div>
          <button className="rb-btn rb-btn--amber rb-btn--full" type="submit" style={{ padding: '13px 24px', fontSize: '0.9rem' }}>
            Sign In
          </button>
        </form>
      </main>
    </div>
  );
};

export default Login;
